import React, { useEffect, useState } from "react";
import { Toaster, toast } from "react-hot-toast";
import Breadcrumbs from "../../components/Breadcrumbs";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import { getJobs } from "../../services/jobs/getJobs";
import { addServiceWithJobs } from "../../services/service/addServiceWithJobs";
import { getServiceDepartments } from "../../services/service/getServiceDepartments";
import { getServiceTasksByJob } from "../../services/serviceTasks/getServiceTasksByJob";
import DepartmentListbox from "./DepartmentListBox";
import JobsListBox from "./JobsListBox";
import { getNewLoggedInEmployeeFunction } from "../../helpers/getLoggedInEmployeeFunction";
import { term } from "../../terms";

function CreateNewServiceWithJobs() {
    const [service, setService] = useState({
        name: "",
        isEfileStatusActive: false,
        department: null,
    });
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [tasks, setTasks] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [jobs, setJobs] = useState([]);
    const [selectedJob, setSelectedJob] = useState({ name: null });
    const [loggedInEmployee, setLoggedInEmployee] = useState(null);

    useEffect(() => {
        getNewDepartments();
        getNewJobs();
        getNewLoggedInEmployeeFunction(setLoggedInEmployee);
    }, []);

    const getNewDepartments = async () => {
        const response = await getServiceDepartments();
        if (response.success) {
            setDepartments(response.data.departments);
            setSelectedDepartment(null);
        } else {
            toast.error(response.data.message);
        }
    };

    const getNewJobs = async () => {
        const response = await getJobs();
        if (response.success) {
            console.log(response.data.jobs);
            setJobs(response.data.jobs);
            /* setSelectedJob(response.data.jobs[0]); */
        } else {
            toast.error(response.data.message);
        }
    };

    const getNewTasks = async (jobId) => {
        const response = await getServiceTasksByJob(jobId);
        if (response.success) {
            setTasks(response.data);
        } else {
            toast.error(response.message);
        }
    };

    const IntialStates = () => {
        setService({
            name: "",
            isEfileStatusActive: false,
            department: null,
        });
        setSelectedDepartment(null);
        setSelectedJob({ name: null });
        setTasks([]);
    };

    /*  const addNewJob = () => {
    setTasks([
      ...tasks,
      {
        id: tasks.length,
        name: "",
        editing: true,
        checklistItems: [{ id: 0, name: "", editing: true }],
      },
    ]);
  }; */

    const onHandleChangeDepartment = (e) => {
        setSelectedDepartment(e);
    };

    const onHandleChangeJob = (e) => {
        setSelectedJob(e);
        getNewTasks(e.id);
    };

    const saveDetails = async () => {
        const trimmedServiceName = service.name.trim();
        if (loggedInEmployee.role === 0) {
            toast.error("You don't have permission to do this");
            return;
        }
        if (trimmedServiceName == "") {
            toast.error("Service name can't be empty");
            return;
        }
        if (!selectedDepartment?.id) {
            toast.error("You need to choose a department");
            return;
        }
        if (selectedJob.name == null) {
            toast.error("You need to choose a pipeline.");
            return;
        }
        const newJobs = tasks
            .filter((job) => job.editing == false)
            .map((job) => {
                return {
                    name: job.name,
                    order: job.id,
                    checklistItems: job.checklistItems,
                };
            });

        const servicesWithJobs = {
            serviceName: trimmedServiceName,
            serviceIsEfileStatusActive: service.isEfileStatusActive,
            serviceDepartment: selectedDepartment.id,
            jobId: selectedJob.id,
            tasks: newJobs,
        };

        const response = await addServiceWithJobs(servicesWithJobs);
        if (response?.data?.success) {
            toast.success(response.data.message);
            IntialStates();
        } else {
            toast.error(
                response?.data?.message ||
                    response?.message ||
                    "Something went wrong",
            );
        }
        console.log(servicesWithJobs);
    };

    return (
        <section>
            <Toaster />
            <div className="flex h-screen overflow-hidden">
                {/* Sidebar */}
                <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                {/* Content area */}
                <div className="relative flex flex-col flex-1 overflow-x-hidden overflow-y-auto">
                    {/*  Site header */}
                    <Header
                        sidebarOpen={sidebarOpen}
                        setSidebarOpen={setSidebarOpen}
                    />

                    <main>
                        <div className="w-full px-4 py-8 mx-auto sm:px-6 lg:px-8 max-w-9xl">
                            <div className="flex flex-col items-start max-w-2xl">
                                <Breadcrumbs
                                    home="/departments"
                                    pages={[
                                        {
                                            name: "Service",
                                            href: `/templates/services/create`,
                                            current: true,
                                        },
                                    ]}
                                />

                                {/* Page header */}
                                <div className="w-full mt-12 mb-8 sm:flex sm:justify-between sm:items-center">
                                    {/* Left: Title */}
                                    <div className="mb-4 sm:mb-0">
                                        <h1 className="text-2xl font-bold md:text-3xl text-slate-800">
                                            New Service
                                        </h1>
                                    </div>
                                </div>

                                <div className="relative w-full bg-white border rounded-sm shadow-lg border-slate-200">
                                    <header className="px-5 py-4 border-b border-slate-200">
                                        <h2 className="font-semibold text-slate-800">
                                            Details
                                        </h2>
                                    </header>

                                    <div className="w-full px-5 py-4 space-y-5">
                                        <div>
                                            <label
                                                htmlFor="serviceName"
                                                className="block text-sm font-medium text-gray-700"
                                            >
                                                Name
                                            </label>
                                            <div className="w-full mt-1">
                                                <input
                                                    type="text"
                                                    onChange={(e) =>
                                                        setService({
                                                            ...service,
                                                            name: e.target.value,
                                                        })
                                                    }
                                                    onBlur={() =>
                                                        setService((prev) => ({
                                                            ...prev,
                                                            name: prev.name.trim(),
                                                        }))
                                                    }
                                                    value={service.name}
                                                    className="w-full p-1 px-2 border rounded-sm shadow-sm border-slate-200 focus:ring-0 focus:outline-none"
                                                />
                                            </div>
                                        </div>
                                        <div className="mt-1">
                                            <DepartmentListbox
                                                label={"Department"}
                                                departments={departments}
                                                selectedDepartment={
                                                    selectedDepartment
                                                }
                                                onChangeDepartment={(e) =>
                                                    onHandleChangeDepartment(e)
                                                }
                                            />
                                        </div>
                                        <div className="mt-1">
                                            <JobsListBox
                                                label={term("pipeline_singular")}
                                                items={jobs}
                                                selectedItem={selectedJob}
                                                onChangeItem={(e) =>
                                                    onHandleChangeJob(e)
                                                }
                                            />
                                        </div>
                                        <label className="flex items-start gap-2">
                                            <input
                                                type="checkbox"
                                                checked={
                                                    service.isEfileStatusActive
                                                }
                                                onChange={(e) =>
                                                    setService((prev) => ({
                                                        ...prev,
                                                        isEfileStatusActive:
                                                            e.target.checked,
                                                    }))
                                                }
                                                className="mt-1 rounded border-slate-300 text-teal-600 focus:ring-teal-500"
                                            />
                                            <span>
                                                <span className="block text-sm font-medium text-gray-700">
                                                    E-file Status applies to client
                                                    services using this template.
                                                </span>
                                                <span className="block text-sm text-slate-500">
                                                    Enable this setting when those
                                                    client services require an E-file
                                                    workflow.
                                                </span>
                                            </span>
                                        </label>
                                        {/*  <ServiceStatusesListBox
                        label="Service status *"
                        serviceStatuses={serviceStatuses}
                        selectedServiceStatus={service.serviceState}
                        onChange={onHandleChangeStatus}
                      /> */}
                                    </div>
                                </div>

                                <div className="relative w-full mt-12 bg-white border rounded-sm shadow-lg border-slate-200">
                                    <header className="flex items-center justify-between w-full px-5 py-4 border-b border-slate-200">
                                        <h2 className="font-semibold text-slate-800">
                                            {term("step_plural")} assigned to current{" "}
                                            {term("pipeline_singular")}
                                        </h2>
                                    </header>

                                    {tasks.map((task) => (
                                        <div className="w-full py-2 pl-4 m-2 text-sm">
                                            <div className="flex items-center w-full">
                                                <h1
                                                    htmlFor="comments"
                                                    className="w-full font-medium text-gray-700"
                                                >
                                                    {task.name}
                                                </h1>
                                            </div>
                                        </div>
                                    ))}

                                    {/*   <CreateJobsForServiceSection
                    jobs={tasks}
                    setJobs={setTasks}
                  /> */}
                                </div>
                                <div className="flex justify-end w-full">
                                    <button
                                        onClick={() => saveDetails()}
                                        className="z-50 inline-flex justify-center px-4 py-2 mt-4 ml-3 text-sm font-medium text-white bg-teal-500 border border-transparent rounded-sm shadow-sm hover:bg-teal-600 focus:outline-none focus:ring-0"
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        </section>
    );
}
export default CreateNewServiceWithJobs;
